import { render, staticRenderFns } from "./Resumo.vue?vue&type=template&id=5a2a9638"
import script from "./Resumo.vue?vue&type=script&lang=ts"
export * from "./Resumo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports